import { render, staticRenderFns } from "./board-details.vue?vue&type=template&id=0bd7a1da&scoped=true&"
import script from "./board-details.vue?vue&type=script&lang=js&"
export * from "./board-details.vue?vue&type=script&lang=js&"
import style0 from "./board-details.vue?vue&type=style&index=0&id=0bd7a1da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd7a1da",
  null
  
)

export default component.exports